import { render, staticRenderFns } from "./FlowUI.vue?vue&type=template&id=56f847a8&scoped=true&"
import script from "./FlowUI.vue?vue&type=script&lang=ts&"
export * from "./FlowUI.vue?vue&type=script&lang=ts&"
import style0 from "./FlowUI.vue?vue&type=style&index=0&id=56f847a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f847a8",
  null
  
)

export default component.exports